// File type validation - now includes CSV, Excel, and PowerPoint files
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
  'text/csv', // .csv
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'text/plain', // .txt
]

const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes

// Returns an i18n key (under the `chat` namespace) describing the failure, or
// null when the file is valid. Callers translate the key so error messages
// follow the user's selected language.
export type FileValidationError = 'fileTypeNotAllowed' | 'fileTooLarge'

export function validateFile(file: File): FileValidationError | null {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return 'fileTypeNotAllowed'
  }

  if (file.size > MAX_FILE_SIZE) {
    return 'fileTooLarge'
  }

  return null
}

// Image file type validation
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export function validateImageFile(file: File): string | null {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Only JPG, PNG, and WEBP images are allowed'
  }

  if (file.size > MAX_FILE_SIZE) {
    return 'File size must be less than 10MB'
  }

  return null
}
